export const GET_PATIENT_DETAILS: string = 'GET_PATIENT_DETAILS'
export const GET_PATIENT_DETAILS_SUCCESS: string = 'GET_PATIENT_DETAILS_SUCCESS'
export const GET_PATIENT_DETAILS_FAILURE: string = 'GET_PATIENT_DETAILS_FAILURE'
export const GET_PATIENT_SHARED: string = 'GET_PATIENT_SHARED'
export const GET_PATIENT_SHARED_SUCCESS: string = 'GET_PATIENT_SHARED_SUCCESS'
export const GET_PATIENT_SHARED_FAILURE: string = 'GET_PATIENT_SHARED_FAILURE'
export const PUT_PATIENT_SHARED: string = 'PUT_PATIENT_SHARED'
export const PUT_PATIENT_SHARED_SUCCESS: string = 'PUT_PATIENT_SHARED_SUCCESS'
export const PUT_PATIENT_SHARED_FAILURE: string = 'PUT_PATIENT_SHARED_FAILURE'
export const POST_PATIENT_PASSWORD_CHANGE: string = 'POST_PATIENT_PASSWORD_CHANGE'
export const POST_PATIENT_PASSWORD_CHANGE_SUCCESS: string = 'GET_PATIENT_PASSWORD_CHANGE_SUCCESS'
export const POST_PATIENT_PASSWORD_CHANGE_FAILURE: string = 'GET_PATIENT_PASSWORD_CHANGE_FAILURE'



// WEBPACK FOOTER //
// ./src/constants/patient.constant.ts